export default function Hero() {
  return (
    <section className="relative overflow-hidden" style={{ minHeight: '90vh' }}>
      <div
        className="absolute inset-0 -z-10"
        style={{
          backgroundImage: "url('/fondo.JPG')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div
        className="absolute inset-0 -z-10"
        style={{
          background: 'linear-gradient(135deg, rgba(30,37,120,0.90) 0%, rgba(46,56,164,0.78) 55%, rgba(245,160,32,0.25) 100%)',
        }}
      />

      <div className="mx-auto max-w-7xl px-6 lg:px-8 flex flex-col justify-center" style={{ minHeight: '90vh' }}>
        <div className="mx-auto max-w-3xl lg:mx-0">

          <p className="text-sm font-semibold uppercase tracking-widest mb-5" style={{ color: '#F5A020' }}>
            Agencia de viajes — Guatemala
          </p>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-white leading-tight tracking-tight">
            Tu próxima aventura <br />
            <span style={{ color: '#F5A020' }}>empieza aquí.</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg text-white/75 leading-relaxed">
            En <strong className="text-white font-semibold">Despega GT</strong> hacemos que viajar sea fácil, seguro y emocionante.
            Tours, paquetes, visas y más — todo en un solo lugar.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#tours"
              className="inline-flex items-center px-8 py-4 rounded-xl font-bold text-white text-base shadow-lg transition hover:opacity-90"
              style={{ background: '#F5A020' }}
            >
              Ver Tours
            </a>
            <a
              href={`https://wa.me/50239990332?text=${encodeURIComponent('Hola, quiero cotizar un viaje con Despega GT')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-4 rounded-xl font-bold text-white text-base transition hover:bg-white/20"
              style={{ border: '2px solid rgba(255,255,255,0.45)' }}
            >
              Cotiza gratis
            </a>
          </div>

          <div className="mt-14 flex flex-wrap gap-3">
            {['Tours', 'Paquetes', 'Visas', 'Pasaportes', '+50 Países'].map((s) => (
              <span
                key={s}
                className="px-4 py-2 rounded-full text-sm font-medium text-white/80"
                style={{ background: 'rgba(255,255,255,0.10)', border: '1px solid rgba(255,255,255,0.18)' }}
              >
                {s}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <svg className="w-5 h-5 text-white/40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </section>
  );
}
